import { FilterDefinition } from 'src/app/paginated-table/filter-panel/filter-panel.component';

const ACCOUNT_STATES = [
  { label: $localize`:filters|state values:New`, value: 'new' },
  { label: $localize`:filters|state values:Active`, value: 'active' },
  { label: $localize`:filters|state values:Suspended`, value: 'suspended' },
]

export const FILTER_DEFINITIONS: FilterDefinition[] = [
  {
    label: $localize`:filters|Filter name:Status`,
    operators: [
      { label: $localize`:filters|Operator name:is`, inputType: 'multiselect', operator: 'withStates', possibleValues: ACCOUNT_STATES },
      { label: $localize`:filters|Operator name:is not`, inputType: 'multiselect', operator: 'withoutStates', possibleValues: ACCOUNT_STATES }
    ]
  },
  {
    label: $localize`:filters|Filter name:Company`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'company' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'company' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Street`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'street' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'street' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Zip`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'zip' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'zip' }
    ]
  },
  {
    label: $localize`:filters|Filter name:City`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'city' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'city' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Country`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'country' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'country' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Fax`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'fax' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'fax' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Phone`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'phone' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'phone' }
    ]
  },
]
